import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import useStyles from '../styles'

function ImageUpload({ image, onImageChange }) {
  const classes = useStyles()

  return (
    <Grid item>
      <div className={classes.box}>
        <h4>Adicionar imagem destacada</h4>
        <div>
          <label>
            {image ? (
              <img
                className={classes.img}
                src={image instanceof File ? URL.createObjectURL(image) : `${process.env.REACT_APP_IMAGES_URL}${image}`}
                alt="Imagem destacada"
              />
            ) : null}
            <span className={classes.plainButton}>Selecionar arquivo</span>
            <input
              className={classes.hiddenInput}
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onImageChange}
            />
          </label>
          <span className={classes.legend}>Arquivo .png/.jpg/.jpeg</span>
        </div>
      </div>
    </Grid>
  )
}

ImageUpload.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
  onImageChange: PropTypes.func.isRequired,
}

ImageUpload.defaultProps = {
  image: null
}

export default ImageUpload
